import React from 'react';
import {useForm} from 'react-hook-form';

import Pagina, {CheckboxReactHookForm, esMayorOIgualACero} from "../comun/Pagina";
import SelectReactHookForm from "../comun/SelectReactHookForm";

import otrosEfectos from "../../img/otros_efectos.png";
import Boton from '../comun/Boton';

export default function Pagina4(props) {
    const {register, handleSubmit, getValues, watch, formState:{errors}} = useForm();
    
    const onSubmit =(data)=>{                 
        props.mergeEstadoFinal(data);        
    }
    console.log("pagina 4");

    return (
        <Pagina
        titulo="Efectos en objetos y construcciones"
        imgSrc={otrosEfectos}
        imgAlt="Efectos en construcciones"
        botonesNavegacion={<BotonesEnvioAtras retrocederPagina={props.retrocederPagina}/>}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}                
        explicacion={
            <React.Fragment>
                Por favor describe los efectos adicionales que percibiste durante el sismo y si quieres proporciónanos tus datos de contacto para posibles inquietudes
            </React.Fragment>
        }
        
        contenidoPrincipal= {
            <React.Fragment>
            <div style={{marginLeft:"20px", marginRight: "20px",  height:"100%", 
            display:"flex", flexDirection:"column",
            justifyContent:"space-evenly"}}>
                <div>
                    <div className="TextoMedianoVerde">¿Tienes algún comentario adicional sobre el sismo?</div>
                    <textarea rows="7" style={{ width:"700px", resize: "none"}} id="ef_ad_adicional" name="ef_ad_adicional" 
                    placeholder='Por ejemplo: deslizamientos, grietas en el suelo, duración, ruido, dirección del movimiento, etc.'
                    {...register("ef_ad_adicional")}/>
                </div>

                <div>
                <div className="TextoMedianoVerde" style={{paddingLeft:"50px"}}>
                    Información de contacto (opcional)
                </div>
                <table style={{margin:"0 auto"}}>
                    <tbody>
                    <tr>
                        <td style={{width: "50px"}}>Nombre</td>
                        <td>
                            <input type="text" style={{width:"300px"}}
                            name="contacto_nombre" maxLength="100" {...register("contacto_nombre")}/></td>
                    </tr>
                    <tr >
                        <td style={{width: "50px"}}>E-mail</td>					
                        <td>
                            <input type="text" style={{width:"300px"}}
                            name="contacto_correo" maxLength="100" {...register("contacto_correo")}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            </div>
            </React.Fragment>
        }
        />
    );
}

const BotonesEnvioAtras = ({retrocederPagina}) => {
    return (        
        <div style={{marginBottom:"10px"}}>        
            <Boton texto="Anterior" onClick={retrocederPagina} />
            &nbsp;              
            <Boton texto="Enviar" tipo="submit" />
        </div>
    )
}